// removed by extract-text-webpack-plugin
module.exports = {"applePayButton":"Gc45617","applePayButtonText":"G63fa6e","applePayButtonLogo":"Geaccaa"};